import { useShowContext } from 'framework/show';
import { CreatePageLayout, ShowSection } from 'framework/ui/layout';
import { SummaryReviewDetails } from '../types';
import SummaryReviewResult from './SummaryReviewResult';
import SummaryReviewBreadcrumbs from './SummaryReviewBreadcrumbs';

const SummaryReviewContent = () => {
  const { data } = useShowContext<SummaryReviewDetails>();
  const review = data.getData();

  return (
    <CreatePageLayout
      breadcrumbs={<SummaryReviewBreadcrumbs />}
      buttons={<></>}
      hasSeparateSections
      isCancelButtonVisible={false}
    >
      <ShowSection title="Review Summary" titleVariant="h2">
        <SummaryReviewResult review={review} />
      </ShowSection>
    </CreatePageLayout>
  );
};

export default SummaryReviewContent;
